module.exports = __webpack_public_path__ + "img/icon_inject.005b2fe5.svg";